"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const translation_1 = require("../../../common/js/helper/translation");
const ShopwareContext_1 = __importDefault(require("../../stores/ShopwareContext"));
const ShopwareProducts_1 = __importDefault(require("../../stores/ShopwareProducts"));
const ProductList_1 = __importDefault(require("../ProductList"));
class SoftwareOverviewPage extends react_1.default.Component {
    contextReactionDisposer;
    cachedProducts = new Map();
    internalIsLoading = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            cachedProducts: mobx_1.observable,
            internalIsLoading: mobx_1.observable,
            products: mobx_1.computed,
            isLoading: mobx_1.computed,
            loadSoftware: mobx_1.action.bound,
        });
    }
    get products() {
        return Array.from(this.cachedProducts.values());
    }
    get isLoading() {
        return this.internalIsLoading || ShopwareContext_1.default.isLoading;
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('software_homepage_title', { title: (0, translation_1.t)('software.overview.title') });
        this.contextReactionDisposer = (0, mobx_1.reaction)(() => ShopwareContext_1.default.customFields?.massiveSoftwareCategory, () => this.loadSoftware(), { fireImmediately: true });
    }
    componentWillUnmount() {
        this.contextReactionDisposer?.();
    }
    render() {
        return (react_1.default.createElement("section", { className: "znd-software-page__overview" },
            react_1.default.createElement("div", { className: "znd-header-page znd-software-page__overview-header d-flex justify-content-between align-items-start flex-column align-items-sm-center flex-sm-row" },
                react_1.default.createElement("div", { className: "znd-header-page-left" },
                    react_1.default.createElement("div", { className: "znd-header-page__title t-headline-2" }, (0, translation_1.t)('software.overview.title')),
                    react_1.default.createElement("div", { className: "znd-header-page__subtitle" }, (0, translation_1.t)('software.overview.subtitle')))),
            react_1.default.createElement("div", { className: "znd-shop-category-page__product-list-wrapper" }, this.isLoading ? (react_1.default.createElement("div", { className: "d-flex justify-content-center" },
                react_1.default.createElement(LoadingSpinner_1.default, null))) : (react_1.default.createElement(ProductList_1.default, { products: this.products, isCategorySoftware: true, forceHidePrice: true, toSoftwareDetail: true })))));
    }
    loadSoftware() {
        const categoryId = ShopwareContext_1.default?.customFields?.massiveSoftwareCategory;
        if (!categoryId) {
            return;
        }
        this.internalIsLoading = true;
        this.cachedProducts.clear();
        ShopwareProducts_1.default.loadProductsForCategory(categoryId, true)
            .then((products) => {
            products?.forEach((product) => {
                this.cachedProducts.set(product.id, product);
            });
        })
            .finally((0, mobx_1.action)(() => {
            this.internalIsLoading = false;
        }));
    }
}
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(SoftwareOverviewPage));
